<template>
  <ScrollAnchor class="kpb-scroll-anchor" :value="data" v-bind="options" />
</template>

<script>
import ScrollAnchor from '@kvass/scroll-anchor'

/** scroll anchor component */
export default {
  props: {
    data: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({
        offset: '-8rem',
        delay: 750,
      }),
    },
  },
  components: {
    ScrollAnchor,
  },
}
</script>
